import styled from 'styled-components';

import { PADDING_PAGE } from '../../../globals';


export const StyledIntervalsContent = styled.div`
  padding: ${PADDING_PAGE}px;

  .service-content-row {
    margin: 0px;
  }

  .service-content-col {
    padding: 0px;
  }
}
`;



// WEBPACK FOOTER //
// ./src/components/IntervalsContent/styles/StyledIntervalsContent.js